import React, { Component } from 'react'
import PropTypes from 'prop-types'
import range from 'lodash/range'
import bindAll from 'lodash/bindAll'

class PublicPagination extends Component {
	constructor(props) {
		super(props);

		bindAll(this, [
			'pageRange',
			'handlePrevLinkClick',
			'handleNextLinkClick',
			'handleLinkClick'
		])
	}

	pageRange() {
		let startPage = 0
		let endPage = 0
		let pages = []

		const totalPages = Math.ceil(this.props.pagination.total / this.props.pagination.per_page)

		if (totalPages <= 10) {
      startPage = 1
      endPage = totalPages
    } else {
      if (this.props.pagination.current_page <= 6) {
        startPage = 1
        endPage = 10
      } else if (this.props.pagination.current_page + 4 >= totalPages) {
        startPage = totalPages - 9
        endPage = totalPages
      } else {
        startPage = this.props.pagination.current_page - 5
        endPage = this.props.pagination.current_page + 4
      }
    }

		pages = range(startPage, endPage + 1)

		return pages
	}

	handlePrevLinkClick() {
		const pageNumber = this.props.pagination.current_page - 1
		const totalPages = this.props.pagination.total / this.props.pagination.per_page
		const {
			addPageNumber,
			fetchData
		} = this.props

		if (pageNumber < 1 || pageNumber > totalPages){
			return false
		}

		addPageNumber(pageNumber).then(() => {
			fetchData(this.props.filterData)
		})
	}

	handleNextLinkClick() {
		const pageNumber = this.props.pagination.current_page + 1
		const totalPages = this.props.pagination.total / this.props.pagination.per_page
		const {
			addPageNumber,
			fetchData
		} = this.props

		if (pageNumber < 1 || this.props.pagination.current_page > totalPages) {
			return false
		}

		addPageNumber(pageNumber).then(() => {
			fetchData(this.props.filterData)
		})
	}

	handleLinkClick(e) {
		const pageNumber = e.target.dataset.page
		const {
			addPageNumber,
			fetchData
		} = this.props

		addPageNumber(pageNumber).then(() => {
			fetchData(this.props.filterData)
		})
	}

	render() {
		let pages = []
		const totalPages = this.props.pagination.total / this.props.pagination.per_page

		if (totalPages > 1) {
			pages.push(
				<button
					type="button"
					key="page-prev"
					className="btn btn-white"
					onClick={this.handlePrevLinkClick}>
					<i className="fa fa-chevron-left"></i>
				</button>
			)

			let pageRange = this.pageRange()

			for (var i = 0; i < pageRange.length; i++) {
				let pageNumber = pageRange[i]

				if (pageNumber === this.props.pagination.current_page) {
					pages.push(
						<button className="btn btn-white active" key={'page-link-' + pageNumber}>{pageNumber}</button>
					)
				} else {
					pages.push(
						<button
							className="btn btn-white"
							data-page={pageNumber}
							key={"page-link-" + pageNumber}
							onClick={this.handleLinkClick}>
							{pageNumber}
						</button>
					)
				}

			}

			pages.push(
				<button
					type="button"
					key="page-next"
					className="btn btn-white"
					onClick={this.handleNextLinkClick}>

					<i className="fa fa-chevron-right"></i>
				</button>
			)

		} else {
			pages.push(
				<button className="btn btn-white active" key='page-link-1'>1</button>
			)
		}

		return(
			<div className="paginations-wrapper">
			  <div className="progress-page">
			    <b>{this.props.pagination.from} - {this.props.pagination.to}</b> of {this.props.pagination.total}
			  </div>
			  <div className="btn-group">
					{pages}
			  </div>
			</div>
		)
	}
}

PublicPagination.propTypes = {
  fetchData: PropTypes.func.isRequired,
  addPageNumber: PropTypes.func.isRequired,
  filterData: PropTypes.object,
  pagination: PropTypes.object.isRequired
}

export default PublicPagination
